import { useRoutes, Navigate } from 'react-router-dom'
import LoginView from '../../routes/loginView';
import NotFoundView from '../../routes/NotFoundView';

const PublicRoutes = () => {
  const routes = useRoutes([
    {
      path: '/login',
      element: <LoginView />
    },
    {
      path: '/404',
      element: <NotFoundView />
    },
    {
      path: '/',
      element: <Navigate to="/login" replace />
    },
    {
      path: '*',
      element: <Navigate to="/login" replace />
    }
  ]);

  return routes;
}

export { PublicRoutes };
